import {useState, useEffect} from 'react'
import NavBar from '../components/NavBar'
import MovieCard from '../components/MovieCard'
import {useSelector,useDispatch} from "react-redux"
import { fetchMovie, fetchGenre } from "../store/actions"
export default function HomePage(){
  const {genre}= useSelector((state)=>state.movie)
  const {movies}= useSelector((state)=>state.movie)
  const dispatch= useDispatch()
  const[loading,setLoading]= useState(true)
  const [genres,setGenre]= useState("0")
  const [movie, setMovie]= useState([])
  const inputGenre= (e)=>{
    setGenre(e.target.value)
  }

useEffect(()=>{
  dispatch(fetchGenre())
},[])

useEffect(()=>{
  dispatch(fetchMovie())
  .finally(()=>{
      setLoading(false)
  })
},[])

useEffect(()=>{
 if(genres !== '0'){
  const newMovie= movies.filter((el)=> el.genreId == genres)
  setMovie(newMovie)
 }else{
  setMovie(movies)
 }

},[genres,movies])

    return(
      <div className='bg-gray-900 max-w-max bg-fixed'>
        <NavBar/>
        <div className="bg-[url('https://wallpaperaccess.com/full/1347851.jpg')] w-screen h-screen bg-cover">
          <div className='h-screen w-screen' style={{ backgroundColor: "black", opacity:"80%"}}>
            <div className='justify-center items-center text-center flex'>
              <img style={{width: "400px", height: "400px"}} src='https://d3g5ywftkpzr0e.cloudfront.net/wp-content/uploads/2020/01/15094433/hacktiv8-1.png' alt=""/>
            </div>
          <div className='justify-center items-center text-center flex'>
        <h1 className='text-white' style={{fontSize: "80pt", fontWeight: "bold", fontFamily: "monospace"}}>MOVIE HACKTIV 8</h1>
          </div>

          </div>
        </div>
        <div className='pt-5 pb-10'>
          <div className="pb-5">
          <h1 className="text-white pl-7" style={{fontSize: "20pt"}}>MOVIE</h1>
          </div>
          <div className='pl-10 pb-10'>
          <select className="form-select rounded-lg" style={{width:"200px"}} name='genres' value={genres} onChange={inputGenre} aria-label="Default select example">
              <option value="0">All</option>
              {genre.map((el)=>
              <option key={el.id} value={el.id}>{el.name}</option>
              )}
          </select>

          </div>
          <div className="justify-center items-center flex content-center pl-10 pr-10">
        <div className="justify-center items-center grid grid-cols-3 gap-3">
          {loading ? <lottie-player src="https://assets6.lottiefiles.com/packages/lf20_xZnfP1Lqj1.json"  background="transparent"  speed="1"  style={{width: "500px", height: "400px"}} loop autoplay></lottie-player>: movie.length== 0 ? <h1 className='text-white' style={{fontSize: "30pt"}}>No movie with this genre</h1> :movie.map((movie)=>
         <MovieCard movie={movie} key={movie.id}/>
          )}
        </div>
          </div>
        </div>
      </div>
    )
      
}